
import { BusinessCardData } from "./types";

/**
 * Recognizes business cards from an image by calling the backend API.
 */
export const recognizeBusinessCards = async (base64Image: string): Promise<BusinessCardData[]> => {
  try {
    const response = await fetch('/api/recognize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ image: base64Image }),
    });

    if (!response.ok) {
      let errorMessage = response.statusText;
      try {
        const errorData = await response.json() as any;
        if (errorData.error) {
          errorMessage = errorData.error;
        }
      } catch (e) {
        // Ignore JSON parse error if response body is not JSON
      }
      throw new Error(`Server error: ${errorMessage}`);
    }

    const data = await response.json();
    return data as BusinessCardData[];
  } catch (error) {
    console.error("Failed to recognize cards", error);
    return [];
  }
};

/**
 * Searches for background information calling the backend API.
 */
export const searchCardInfo = async (name: string, company?: string): Promise<{ text: string; sources: any[] }> => {
  try {
    const response = await fetch('/api/search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, company }),
    });

    if (!response.ok) {
      return {
        text: "無法取得資訊 (Server Error)",
        sources: []
      };
    }

    return await response.json();

  } catch (error) {
    console.error("Failed to search info", error);
    return {
      text: "無法取得資訊。",
      sources: [],
    };
  }
};
